import { useId } from "react";

const useAlphaNumId = () => {
    const _id = useId();
    return _id.match(/[0-9a-zA-Z]+/)![0];
};
export default useAlphaNumId;
